import { memo, useCallback } from 'react';
import { useTranslation } from '@betty/i18n';
import { useDispatch, useSelector, verifyIdentity } from '@betty/toolkit/state';
import { LobbyWidget } from '@betty/moonlight';
import { selectWelcomePromos } from '@betty/promos/state';
import {
  selectDepositCountState,
  selectHasUserDeposited,
} from '@betty/wallet/state';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { selectAccountStatus } from '@betty/account';

function WelcomeLobbyWidget() {
  const dispatch = useDispatch();
  const [t] = useTranslation('onboarding');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const accountStatus = useSelector(selectAccountStatus);
  const hasUserDeposited = useSelector(selectHasUserDeposited);
  const depositCountState = useSelector(selectDepositCountState);
  const welcomePromos = useSelector(selectWelcomePromos);

  const handleClick = useCallback(() => {
    if (accountStatus !== 'Approved') {
      dispatch(verifyIdentity());
    } else {
      navigation.navigate('Promos');
    }
  }, [accountStatus, dispatch, navigation]);

  if (
    depositCountState !== 'fulfilled' ||
    hasUserDeposited ||
    !welcomePromos.length
  ) {
    return null;
  }

  return (
    <LobbyWidget
      image="onboarding.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
      hasUnread
    />
  );
}

export default memo(WelcomeLobbyWidget);
